import { I18nService } from '@/core/services/i18nService';
import { PaymentDisplayModel, AnfrageDisplayModel, PaymentFoerdersummenDisplayModel, GlobalEnumerationsAceMittelabruf, LocalizedTextDisplayModel } from '@/api/model-index';
import { ActivatedRoute } from '@angular/router';
import { Component, inject, Type } from '@angular/core';
import { PortalkonfigurationDisplayModel } from '../../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/portalkonfiguration-display-model';
import { NavigationService } from '@/core/services/navigation.service';
import { PaymentService } from '@/core/services/payment.service';
import { PortalContextService } from '@/core/services/portal-context.service';
import { ComponentService } from '@/core/services/component.service';
import { PendingAmountsComponent } from '../../components/pending-amounts/pending-amounts.component';
import { FundingTableComponent } from '../../components/funding-table/funding-table.component';

@Component({
    selector: 'app-anfrage-fund-funding-amount',
    templateUrl: './funding-amount.component.html',
    styleUrls: ['./funding-amount.component.scss'],
    standalone: false
})
export class FundingAmountComponent {
  public anfrage: AnfrageDisplayModel;
  public fundingAmounts: PaymentFoerdersummenDisplayModel;
  public portalkonfiguration: PortalkonfigurationDisplayModel;
  public type: GlobalEnumerationsAceMittelabruf = GlobalEnumerationsAceMittelabruf.Forderbetrag;
  public portalContextService: PortalContextService = inject(PortalContextService);
  protected componentService = inject(ComponentService);

  public get payments(): PaymentDisplayModel[] {
    if (this.paymentService.payments.length > 0)
      return this.paymentService.payments;

    return [];
  }

  constructor(protected route: ActivatedRoute,
    protected languageservice: I18nService,
    protected navigationService: NavigationService,
    protected paymentService: PaymentService,
  ) {

    this.anfrage = this.portalContextService.CurrentAnfrage;
    this.fundingAmounts = this.route.snapshot.data.fundingAmounts;
    this.portalkonfiguration = this.route.snapshot.data.portalkonfiguration;
  }

  public get abschnittInfotext(): string {
    let infotext: LocalizedTextDisplayModel | undefined = this.languageservice.getCurrentLocalizedTextDisplayModel(this.portalkonfiguration.mittelabrufAbschnitt?.infotext);
    return infotext?.text ?? "";
  }

  public get pendingAmountsComponent(): Type<PendingAmountsComponent> {
    return this.componentService.get(PendingAmountsComponent);
  }

  public get fundingTableComponent(): Type<FundingTableComponent> {
    return this.componentService.get(FundingTableComponent);
  }
}
